import { createVNode as _createVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, withScopeId as _withScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-f26a342c")

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_MAMarketoForm = _resolveComponent("MAMarketoForm")
  const _component_MAHubspotForm = _resolveComponent("MAHubspotForm")
  const _component_MAPardotForm = _resolveComponent("MAPardotForm")
  const _component_MADynamics365Form = _resolveComponent("MADynamics365Form")
  const _component_Modal = _resolveComponent("Modal")

  return (_openBlock(), _createBlock(_component_Modal, {
    ref: "modal",
    size: "small",
    shown: _ctx.shown,
    "onUpdate:shown": _cache[1] || (_cache[1] = ($event: any) => (_ctx.shown = $event))
  }, {
    default: _withId(() => [
      _createVNode("div", null, [
        _createVNode("h2", {
          class: "pt-0 pb-0 mt-0 mb-3",
          innerHTML: _ctx.formTitle
        }, null, 8, ["innerHTML"])
      ]),
      (_ctx.shown)
        ? (_openBlock(), _createBlock("div", { key: _ctx.key }, [
            (_ctx.ma?.type == 'Marketo')
              ? (_openBlock(), _createBlock(_component_MAMarketoForm, {
                  key: 0,
                  config: _ctx.ma,
                  onFormsubmitted: _ctx.formSubmitted
                }, null, 8, ["config", "onFormsubmitted"]))
              : (_ctx.ma?.type == 'Hubspot')
                ? (_openBlock(), _createBlock(_component_MAHubspotForm, {
                    key: 1,
                    config: _ctx.ma,
                    onFormsubmitted: _ctx.formSubmitted
                  }, null, 8, ["config", "onFormsubmitted"]))
                : (_ctx.ma?.type == 'Pardot')
                  ? (_openBlock(), _createBlock(_component_MAPardotForm, {
                      key: 2,
                      config: _ctx.ma,
                      onFormsubmitted: _ctx.formSubmitted
                    }, null, 8, ["config", "onFormsubmitted"]))
                  : (_ctx.ma?.type == 'Dynamics365')
                    ? (_openBlock(), _createBlock(_component_MADynamics365Form, {
                        key: 3,
                        config: _ctx.ma,
                        onFormsubmitted: _ctx.formSubmitted
                      }, null, 8, ["config", "onFormsubmitted"]))
                    : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["shown"]))
})